module.exports = __webpack_public_path__ + "img/banner_01.f867766a.png";